export default {
  terms:
    'By placing your order, you agree to our <TermsLink>Terms and Conditions</TermsLink> and our <PrivacyPolicyLink>Privacy Policy</PrivacyPolicyLink>.',
};
